module.exports = __webpack_public_path__ + "static/media/citizenship-icon.16b07814.png";